import { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { MessageContext } from '@/helpers/MessageProvider';

const useMissionCommand = () => {
  const { publishCommand } = useContext(MessageContext);

  const clear = (flightId) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => {
      return publishCommand(robot, 'mission/clear', [tid, bid, Date.now(), flightId]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/flighttask_undo`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const pause = () => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => {
      return publishCommand(robot, 'mission/pause', [tid, bid, Date.now()]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/flighttask_pause`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const resume = () => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => {
      return publishCommand(robot, 'mission/resume', [tid, bid, Date.now()]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/flighttask_recovery`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const start = (flightId) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => {
      return publishCommand(robot, 'mission/start', [tid, bid, Date.now(), flightId]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/flighttask_execute`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const upload = (flightId, url, checksum) => (robot) => {
    const execute = () => {
      const timestamp = Date.now();
      return publishCommand(robot, 'mission/upload', [
        uuidv4(),
        uuidv4(),
        timestamp,
        flightId,
        timestamp,
        url,
        checksum,
      ]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/flighttask_ready`,
      isSuccess: ({ data }) => data.flight_ids.includes(flightId),
    };
  };

  const uploadSimulation = (flightId, url, checksum) => (robot) => {
    const execute = () => {
      const timestamp = Date.now();
      return publishCommand(robot, 'mission/upload/simulation', [
        uuidv4(),
        uuidv4(),
        timestamp,
        flightId,
        timestamp,
        url,
        checksum,
      ]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/flighttask_ready`,
      isSuccess: ({ data }) => data.flight_ids.includes(flightId),
    };
  };

  return {
    clear,
    pause,
    resume,
    start,
    upload,
    uploadSimulation,
  };
};

export default useMissionCommand;
